// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__pODks","label":"CategoryService_label__3Ads5","location":"CategoryService_location__3lLYm"};